import { Sun, Moon } from 'lucide-react';
import { useConfig } from '@/contexts/ConfigContext';
import { Button } from '@/components/ui/button';
import { AnimatedThemeToggler } from '@/components/ui/AnimatedThemeToggler';

/**
 * Componente flotante para controlar el tema (dark/light) y el idioma (es/en)
 * Posicionado fijo en la esquina inferior derecha
 */
export default function ThemeLanguageToggle() {
  const { theme, language, toggleTheme, toggleLanguage } = useConfig();

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-2">
      {/* Contenedor con fondo borroso */}
      <div className="flex items-center gap-2 bg-background/80 backdrop-blur-md border border-border rounded-lg shadow-lg p-2">
        {/* Botón de Tema Animado */}
        <AnimatedThemeToggler
          className="h-9 w-9 rounded-md hover:bg-accent transition-colors text-foreground"
        />

        {/* Separador visual */}
        <div className="h-6 w-px bg-border" />

        {/* Botón de Idioma */}
        <Button
          onClick={toggleLanguage}
          variant="ghost"
          size="sm"
          className="h-9 px-3 rounded-md hover:bg-accent transition-colors font-semibold min-w-[2.5rem]"
          aria-label={`Cambiar idioma a ${language === 'es' ? 'inglés' : 'español'}`}
          title={`Idioma: ${language === 'es' ? 'Español' : 'English'}`}
        >
          {language === 'es' ? 'ES' : 'EN'}
        </Button>
      </div>
    </div>
  );
}
